module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_top_gold-2ec0443dc10add2a2c2e27d5e45e4768.svg";